app.controller("TimetableRoomsController", [
    "$scope", "TimetableService", "$stateParams", "StaticData", "$state", "$uibModal", "toastr", "ConfirmModal", "usSpinnerService",
    function ($scope, TimetableService, $stateParams, StaticData, $state, $uibModal, toastr, ConfirmModal, usSpinnerService) {
        $scope.totalItems = 0;
        $scope.itemsPerPage = 20;
        $scope.building = $stateParams.building;
        $scope.floor = $stateParams.floor;
        $scope.room = $stateParams.room;
        if ($stateParams.seatCountFrom) $scope.seatCountFrom = $stateParams.seatCountFrom;
        if ($stateParams.seatCountTo) $scope.seatCountTo = $stateParams.seatCountTo;
        if ($stateParams.withComputers == 'true') $scope.withComputers = true;
        if ($stateParams.withSmartBoard == 'true') $scope.withSmartBoard = true;


        StaticData.getItemsByKey("floors").then(function (floors) {
            $scope.floors = [{name: "სართული"}].concat(floors);
            $scope.daysMap = _.keyBy($scope.foors, '_id');
        });

        StaticData.getItemsByKey("buildings").then(function (buildings) {
            $scope.buildings = [{name: "კორპუსი"}].concat(buildings);
            $scope.buildingsMap = _.keyBy($scope.buildings, '_id');
        });

        loadPage($stateParams.page, function () {
            $scope.currentPage = $stateParams.page;
        });

        $scope.goToPage = function (page) {
            $state.go(".", {page: page});
        };

        $scope.applyFilter = function () {
            $state.go(".", {
                building: $scope.building,
                floor: $scope.floor,
                room: $scope.room,
                seatCountFrom: $scope.seatCountFrom,
                seatCountTo: $scope.seatCountTo,
                withComputers: $scope.withComputers,
                withSmartBoard: $scope.withSmartBoard
            });
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        function loadPage(page, cb) {
            cb = cb || function () {
                };
            usSpinnerService.spin("root");
            TimetableService.list({
                page: page,
                limit: $scope.itemsPerPage,
                building: $scope.building,
                floor: $scope.floor,
                room: $scope.room,
                seatCountFrom: $scope.seatCountFrom,
                seatCountTo: $scope.seatCountTo,
                withComputers: $scope.withComputers,
                withSmartBoard: $scope.withSmartBoard
            }).then(function (data) {
                $scope.rooms = data.docs;
                $scope.totalItems = data.total;
                usSpinnerService.stop("root");
                cb();
            });
        };

        $scope.export = function () {
            TimetableService.exportList()
        };

        $scope.add = function () {
            $uibModal.open({
                controller: "TimetableAddRoomController",
                templateUrl: _pb + 'admin/timetable/timetable-add-room.html',
                size: "md",
                backdrop: 'static',
            }).result
                .then(function (result) {
                    loadPage();
                }, function () {
                });
        };

        $scope.edit = function (room) {
            $uibModal.open({
                controller: "TimetableEditRoomController",
                templateUrl: _pb + 'admin/timetable/timetable-edit-room.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {room: room};
                    }
                }
            }).result
                .then(function (result) {
                    // $scope.fetchRooms();
                    loadPage();
                }, function () {
                });
        };

        $scope.remove = function (room) {
            ConfirmModal.show({
                title: "ოთახის წაშლა",
                message: "ყურადღება! ნამდვილად გსურთ ოთახის წაშლა?"
            }).result.then(function () {
                TimetableService.removeRoom({
                    roomId: room._id
                }).then(function () {
                    toastr.success('', 'ოთახი წარმატებით წაიშალა სიიდან');
                    // $scope.fetchRooms();
                    loadPage();
                });
            });
        };

        $scope.getText = function (room) {
            if(room.withComputers && !room.withSmartBoard) return ', კომპიუტერული';
            else if(!room.withComputers && room.withSmartBoard) return ', სმარტ დაფით';
            else if(room.withComputers && room.withSmartBoard) return ', კომპიუტერული, სმარტ დაფით';
        };
    }
]);
